<template>
    <div>
        <v-dialog persistent
                  v-model="$store.getters.pricingModal"
                  max-width="1100">
            <v-card>
                <v-card-title
                        class="headline primary white--text"
                        primary-title>
                  Εφαρμογή ηλεκτρονικής κοστολόγησης συγγραμμάτων
                </v-card-title>

                <v-card-text class="mt-2">
                    <v-row>
                       <v-col cols="12">
                           <v-toolbar  rounded color="primary" >
                             <v-row>
                               <v-col cols="2"><v-chip color="white" outlined class="mr-2 mt-5">{{this.selectedBookId}}</v-chip></v-col>
                               <v-col cols="8">
                                  <v-chip id="bookTitle" style="text-wrap: normal" color="white" outlined class="mt-5" >
                                   <span class="text-truncate">{{this.bookTitle}}</span>
                                  </v-chip>
                               </v-col>

                               <v-col cols="2">
                                   <v-speed-dial
                                   class="mb-8"
                                   style="margin-left:80px"
                                   fab top right
                                   direction="left"
                                   open-on-hover
                                   v-model="fab">
                                 <template v-slot:activator>
                                   <v-btn small
                                          color="#d4d4d4"
                                          dark
                                          fab
                                          v-model="fab">
                                     <v-icon v-if="fab" color="primary">mdi-close</v-icon>
                                     <v-icon v-else color="primary">mdi-information-outline</v-icon>
                                   </v-btn>
                                 </template>
                                 <v-tooltip top>
                                   <template v-slot:activator="{ on, attrs }">
                                     <v-btn v-on="on"
                                            color="#d4d4d4"
                                            @click="openManual"
                                            dark
                                            fab
                                            small>
                                       <v-icon color="primary">description</v-icon>
                                     </v-btn>
                                   </template>
                                   <span>Οδηγίες βήματος</span>
                                 </v-tooltip>
                                 <v-tooltip top>
                                   <template v-slot:activator="{ on, attrs }">
                                     <v-btn v-on="on"
                                            color="#d4d4d4"
                                            @click="goToUrl('https://eudoxus.gr/files/PublisherCostingManual.pdf')"
                                            dark
                                            fab
                                            small>
                                       <v-icon color="primary">mdi-book-open-variant</v-icon>
                                     </v-btn>
                                   </template>
                                   <span>Οδηγίες εφαρμογής</span>
                                 </v-tooltip>
                               </v-speed-dial></v-col>
                             </v-row>

                           </v-toolbar>
                       </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <v-stepper v-model="e1">
                            <v-stepper-header>

                                <v-stepper-step
                                        :complete="e1 > 1"
                                        editable
                                        step="1">
                                    Βήμα 1
                                </v-stepper-step>

                                <v-divider></v-divider>

                                <v-stepper-step :complete="e1 > 2" step="2" :editable="valid1">
                                    Βήμα 2
                                </v-stepper-step>

                                <v-divider></v-divider>

                                <v-stepper-step :complete="e1 > 3" step="3" :editable="valid2 && valid1">
                                    Βήμα 3
                                </v-stepper-step>

                                <v-divider></v-divider>

                                <v-stepper-step :complete="e1 == 4" @click="stepper4ClickEvent" step="4" :editable="valid3 && valid2 && valid1">
                                    Βήμα 4
                                </v-stepper-step>
                            </v-stepper-header>

                            <v-stepper-items>

                                <v-stepper-content step="1">
                                    <v-card class="mb-2" flat
                                            color="grey lighten-4">
                                        <v-card-text>

                                            <v-form ref="step1" v-model="valid1">
                                                <v-row>
                                                    <v-col>
                                                        <v-select :items="foldingItem"
                                                                  :readonly="readOnlyMode"
                                                                  @change="fieldChanged"
                                                                  dense
                                                                  :item-text="item => item.label +' - σέλιδο '"
                                                                  label="Είδος παραγόμενης εκτύπωσης*"
                                                                  :rules="required"
                                                                  outlined
                                                                  return-object
                                                                  required
                                                                  v-model="pageFolding">
<!--                                                            <template v-slot:selection="{item}">-->
<!--                                                                <span> {{item.label}}-σέλιδο</span>-->
<!--                                                            </template>-->
                                                        </v-select>
                                                        <v-select :items="dimensionItem"
                                                                  :readonly="readOnlyMode"
                                                                  @change="fieldChanged"
                                                                  dense
                                                                  :item-text="item => item.label.includes('x')?  item.label+' εκ. ' : item.label"
                                                                  label="Διαστάσεις συγγράμματος*"
                                                                  :rules="required"
                                                                  outlined
                                                                  item-value="label"
                                                                  required
                                                                  v-model="dimensions"
                                                        ></v-select>
                                                        <v-row class="pl-3  pt-3" v-if="dimensions && Object.keys(dimensions).length > 0 && dimensions == 'Άλλο' ? true : false">

                                                            <v-col cols="6" class="pa-0 justify-start">
                                                                <v-text-field
                                                                        :readonly="readOnlyMode"
                                                                        @change="fieldChanged"
                                                                        dense
                                                                        label="Οριζόντια διάσταση x*"
                                                                        outlined
                                                                        required
                                                                        type="number"
                                                                        min="0"
                                                                        v-model="x"
                                                                        :rules="xRules"
                                                                ></v-text-field>
                                                            </v-col>

                                                            <v-col cols="5" class="pa-0 pl-4 justify-center">
                                                                <v-text-field
                                                                        :readonly="readOnlyMode"
                                                                        @change="fieldChanged"
                                                                        dense
                                                                        label="Κάθετη διάσταση y*"
                                                                        outlined
                                                                        required
                                                                        type="number"
                                                                        min="0"
                                                                        v-model="y"
                                                                        :rules="yRules"
                                                                ></v-text-field>
                                                            </v-col>

                                                            <v-col cols="1" class="pa-0 pt-2 pl-4 justify-end">
                                                                <v-tooltip bottom>
                                                                    <template v-slot:activator="{ on }">
                                                                        <v-icon v-on="on" class="pb-6  "
                                                                                color="primary">mdi-help-circle-outline
                                                                        </v-icon>
                                                                    </template>
                                                                    <span>Το μέγιστο εμβαδόν κοστολόγησης είναι τα 609 τετραγωνικά εκατοστά (21 x 29).<br/>
                                                                        Συγγράμματα με μεγαλύτερο εμβαδόν θα προσαρμόζονται στα 609 τ. εκ..</span>
                                                                </v-tooltip>
                                                            </v-col>
                                                        </v-row>

                                                    </v-col>
                                                    <v-col>
                                                      <v-row>
                                                        <v-text-field
                                                            :readonly="readOnlyMode"
                                                            @change="fieldChanged"
                                                            dense
                                                            label="Αράδες συγγράμματος*"
                                                            outlined
                                                            type="number"
                                                            :rules="lineRules"
                                                            v-model="lines"
                                                        ></v-text-field>
                                                        <v-tooltip left>
                                                          <template v-slot:activator="{ on }">
                                                            <v-icon v-on="on" class="pb-6 ml-1" color="primary">mdi-help-circle-outline</v-icon>
                                                          </template>
                                                          <span>Πυκνότητα γραφής πλήρους σελίδας.</span>
                                                        </v-tooltip>
                                                      </v-row>
                                                      <v-row>
                                                        <v-text-field
                                                            :readonly="readOnlyMode"
                                                            @change="fieldChanged"
                                                            dense
                                                            label="Πλαϊνά περιθώρια συγγράμματος*"
                                                            outlined
                                                            required
                                                            type="number"
                                                            min="0"
                                                            step="0.5"
                                                            :rules="[...sideGapRules, this.sideGapDimensionRule]"
                                                            v-model="sideGap"
                                                        ></v-text-field>
                                                        <v-tooltip left>
                                                          <template v-slot:activator="{ on }">
                                                            <v-icon v-on="on" class="pb-6 ml-1" color="primary">mdi-help-circle-outline</v-icon>
                                                          </template>
                                                          <span>Το εσωτερικό και εξωτερικό οριζόντιο περιθώριο, αθροιστικά, σε εκατοστά.</span>
                                                        </v-tooltip>
                                                      </v-row>

                                                      <v-row class="pl-5">
                                                        <v-checkbox
                                                            :readonly="readOnlyMode || readOnlyFiberBindingFromPageFolding"
                                                            @change="fieldChanged"
                                                            color="primary"
                                                            label="Κλωστοραφή"
                                                            v-model="fiberBinding"
                                                        ></v-checkbox>
                                                        <v-tooltip left>
                                                          <template v-slot:activator="{ on }">
                                                            <v-icon v-on="on" class="ml-1" color="primary">mdi-help-circle-outline</v-icon>
                                                          </template>
                                                          <span>
                                                            Βιβλιοδεσία συγγράμματος με χρήση κλωστοραφής.
                                                          </span>
                                                        </v-tooltip>
                                                      </v-row>
                                                    </v-col>
                                                </v-row>
                                            </v-form>

                                        </v-card-text>
                                    </v-card>
                                    <v-row class="justify-end">
                                        <v-btn  :disabled="!valid1"
                                                color="primary"
                                                @click="e1 = 2">
                                            Συνέχεια <v-icon>chevron_right</v-icon>
                                        </v-btn>
                                    </v-row>

                                </v-stepper-content>

                                <v-stepper-content step="2">

                                    <v-card class="mb-2" flat
                                            color="grey lighten-4">
                                        <v-card-text>
                                            <v-form class="ml-5" ref="step2" v-model="valid2" >
                                                <v-row>
                                                    <v-col>
                                                      <v-row>
                                                          <v-text-field
                                                                dense
                                                                :readonly="readOnlyMode"
                                                                label="Συνολικές σελίδες πριν τα κεφάλαια*"
                                                                @change="fieldChanged"
                                                                outlined
                                                                required
                                                                type="number"
                                                                min="0"
                                                                max="3000"
                                                                :rules="pagesRulesThatAllowZero"
                                                                v-model="preChapterPages"
                                                        ></v-text-field>
                                                        <v-tooltip top>
                                                          <template v-slot:activator="{ on }">
                                                            <v-icon v-on="on" class="pb-6 ml-1" color="primary">mdi-help-circle-outline</v-icon>
                                                          </template>
                                                          <span>Οι συνολικές σελίδες μέχρι το 1ο κεφάλαιο του συγγράμματος.</span>
                                                        </v-tooltip>
                                                        </v-row>
                                                        <v-row>
                                                          <v-text-field
                                                              dense
                                                              :readonly="readOnlyMode"
                                                              label="Συνολικές σελίδες κεφαλαίων*"
                                                              @change="fieldChanged"
                                                              outlined
                                                              required
                                                              type="number"
                                                              min="1"
                                                              max="3000"
                                                              :rules="pagesRules"
                                                              v-model="chapterPages"
                                                          ></v-text-field>
                                                          <v-tooltip top>
                                                            <template v-slot:activator="{ on }">
                                                              <v-icon v-on="on" class="pb-6 ml-1" color="primary">mdi-help-circle-outline</v-icon>
                                                            </template>
                                                            <span>
                                                              Οι συνολικές σελίδες από το 1ο κεφάλαιο έως και το τέλος του
                                                              τελευταίου κεφαλαίου.
                                                            </span>
                                                          </v-tooltip>
                                                        </v-row>
                                                        <v-row>
                                                            <v-col cols="5" class="pa-0 justify-start">
                                                                <v-text-field label="Αρ. πρώτης σελ. κεφαλαίων*"
                                                                              dense outlined
                                                                              @change="fieldChanged"
                                                                              v-model="firstChapterPage"
                                                                              required
                                                                              :readonly="readOnlyMode"
                                                                              type="number"
                                                                              min="1"
                                                                              :rules="[firstChapterPageRule]">
                                                                </v-text-field>
                                                            </v-col>

                                                            <v-col cols="6" class="pa-0 pl-4 justify-center">
                                                                <v-text-field label="Αρ. τελευταίας σελ. κεφαλαίων"
                                                                              dense outlined
                                                                              v-model="lastChapterPage"
                                                                              disabled
                                                                              type="number">
                                                                </v-text-field>
                                                            </v-col>

                                                            <v-col cols="1" class="pa-0 pt-2 pl-4 justify-end">
                                                                <v-tooltip left>
                                                                    <template v-slot:activator="{ on }">
                                                                        <v-icon v-on="on" class="pb-6  "
                                                                                color="primary">mdi-help-circle-outline
                                                                        </v-icon>
                                                                    </template>
                                                                    <span>Συμπληρώνεται με τον αριθμό που εμφανίζεται στο φύλλο<br/>
                                                                        της πρώτης σελίδας του πρώτου κεφαλαίου. Η τελευταία<br/>
                                                                        σελίδα του τελευταίου κεφαλαίου υπολογίζεται αυτόματα.</span>
                                                                </v-tooltip>
                                                            </v-col>
                                                        </v-row>
                                                        <v-row>
                                                          <v-text-field
                                                              dense
                                                              :readonly="readOnlyMode"
                                                              label="Συνολικές σελίδες μετά τα κεφάλαια*"
                                                              @change="fieldChanged"
                                                              outlined
                                                              required
                                                              type="number"
                                                              min="0"
                                                              max="3000"
                                                              :rules="pagesRulesThatAllowZero"
                                                              v-model="postChapterPages"
                                                          ></v-text-field>
                                                          <v-tooltip top>
                                                            <template v-slot:activator="{ on }">
                                                              <v-icon v-on="on" class="pb-6 ml-1" color="primary">mdi-help-circle-outline</v-icon>
                                                            </template>
                                                            <span>Οι συνολικές σελίδες μετά το τέλος του τελευταίου κεφαλαίου.</span>
                                                          </v-tooltip>
                                                        </v-row>

                                                    </v-col>
                                                    <v-col>

                                                        <v-row class="pl-4">
                                                            <v-text-field  :disabled="readOnlyMode "
                                                                    dense
                                                                    label="Συνολικές τεχνικές σελίδες πριν τα κεφάλαια"
                                                                    outlined
                                                                    :rules="[technicalPreChapterPagesRule]"
                                                                    type="Number"
                                                                    v-model="technicalPreChapterPages"
                                                            ></v-text-field>
                                                            <v-tooltip left>
                                                                <template v-slot:activator="{ on }">
                                                                    <v-icon v-on="on" class="pb-6 ml-1" color="primary">mdi-help-circle-outline</v-icon>
                                                                </template>
                                                                <span>
                                                              Δεν δύναται να ξεπερνάνε τις «Συνολικές σελίδες πριν τα κεφάλαια».
                                                            </span>
                                                            </v-tooltip>
                                                        </v-row>
                                                        <v-row class="pl-4">
                                                            <v-col cols="11" class="pa-0">
                                                                <v-expansion-panels class="pb-6">
                                                                    <v-expansion-panel>
                                                                        <v-expansion-panel-header :color="changeColor(technicalPagesString)">
                                                                            Τεχνικές σελίδες
                                                                        </v-expansion-panel-header>
                                                                        <v-expansion-panel-content>
                                                                            <v-textarea
                                                                                    rows="5"
                                                                                    row-height="3"
                                                                                    @change="fieldChanged"
                                                                                    counter
                                                                                    clearable
                                                                                    :rules="[technicalPageFieldValidation(technicalPagesString)]"
                                                                                    v-model="technicalPagesString">
                                                                            </v-textarea>
                                                                        </v-expansion-panel-content>
                                                                    </v-expansion-panel>
                                                                </v-expansion-panels>
                                                            </v-col>
                                                            <v-col cols="1">
                                                                <v-tooltip left>
                                                                    <template v-slot:activator="{ on }">
                                                                        <v-icon v-on="on" class="pb-6 ml-1" color="primary">mdi-help-circle-outline</v-icon>
                                                                    </template>
                                                                    <span>
                                                                      Δηλώνονται μόνο διαστήματα σελίδων ή ακέραιες σελίδες. Π.χ. 40-45 ,46,52,<br/>
                                                                        60-64 κλπ. σε αύξουσα σειρά, χωρίς κενά. Ως τεχνική σελίδα χαρακτηρίζεται<br/>
                                                                        αυτή που περιέχει εικόνες ή μαθηματικούς τύπους ή πίνακες ή διαγράμματα ή <br/>
                                                                        σχήματα ή προγραμματιστικό κώδικα ή παρτιτούρες.
                                                                    </span>
                                                                </v-tooltip>
                                                            </v-col>
                                                        </v-row>
                                                        <v-text-field
                                                                class="pl-1 pr-4"
                                                                dense
                                                                label="Συνολικές σελίδες"
                                                                outlined
                                                                disabled
                                                                v-model="computeTotalPages"
                                                                read-only
                                                        ></v-text-field>
                                                        <v-row class="pl-4">
                                                          <v-text-field
                                                                  dense
                                                                  label="Κατηγορία συγγράμματος"
                                                                  outlined
                                                                  disabled
                                                                  v-model="bookCategories"
                                                          ></v-text-field>
                                                          <v-tooltip left>
                                                            <template v-slot:activator="{ on }">
                                                              <v-icon v-on="on" class="pb-6 ml-1" color="primary">mdi-help-circle-outline</v-icon>
                                                            </template>
                                                            <span>
                                                              Για την υπαγωγή ενός διδακτικού συγγράμματος στην κατηγορία <br/>
                                                              «ιατρικό-μαθηματικό-τεχνικό-τέχνης-μουσικό» προϋποτίθεται <br/>
                                                              ότι αυτό περιέχει εικόνες ή μαθηματικούς τύπους ή πίνακες <br/>
                                                              ή διαγράμματα ή σχήματα ή προγραμματιστικό κώδικα ή παρτιτούρες <br/>
                                                              σε ποσοστό μεγαλύτερο του 40% του συνολικού αριθμού των σελίδων του. <br/>
                                                              Σε διαφορετική περίπτωση το σύγγραμμα θα θεωρείται «απλό».
                                                            </span>
                                                          </v-tooltip>
                                                        </v-row>
                                                    </v-col>
                                                </v-row>
                                            </v-form>
                                        </v-card-text>
                                    </v-card>
                                    <v-row class="justify-center">
                                        <v-btn  color="primary"
                                                class="mr-1"
                                                @click="e1 = 1">
                                            <v-icon>chevron_left</v-icon> Πίσω
                                        </v-btn>
                                        <v-btn  color="primary"
                                                @click="step2Validation">
                                            Συνέχεια <v-icon>chevron_right</v-icon>
                                        </v-btn>
                                    </v-row>
                                </v-stepper-content>

                                <v-stepper-content step="3">

                                    <v-card class="mb-2" flat
                                            color="grey lighten-4">
                                        <v-card-text>
                                            <v-form ref="step3" v-model="valid3">
                                                <v-row>
                                                    <v-col>
                                                        <v-row v-if="isTechnicalBook" class="px-2">
                                                            <v-text-field
                                                                    :readonly="readOnlyMode"
                                                                    dense type="number"
                                                                    label="Συνολικές σελ. με παραρτήματα μεταξύ των κεφαλαίων"
                                                                    @change="fieldChanged"
                                                                    outlined
                                                                    :rules="[checkTotalSingleColorChapterPagesRule()]"
                                                                    v-model="totalSingleColorChapterPages"
                                                            ></v-text-field>
                                                            <v-tooltip left>
                                                                <template v-slot:activator="{ on }">
                                                                    <v-icon v-on="on" class="pb-6 ml-1" color="primary">mdi-help-circle-outline</v-icon>
                                                                </template>
                                                                <span>
                                                                  Συμπληρώνεται από το συνολικό πλήθος σελίδων με βιβλιογραφικές <br/>
                                                                  παραπομπές και κάθε είδους παραρτήματα μεταξύ των κεφαλαίων για τις <br/>
                                                                  πρώτες 900 σελίδες του συγγράμματος.
                                                            </span>
                                                            </v-tooltip>
                                                        </v-row>
                                                        <v-row v-if="isTechnicalBook" class="px-2">
                                                            <v-col cols="11" class="pa-0">
                                                                <v-expansion-panels class="pb-6">
                                                                    <v-expansion-panel>
                                                                        <v-expansion-panel-header
                                                                                :color="changeColor(colorPagesString)">
                                                                            Τετράχρωμες σελίδες
                                                                        </v-expansion-panel-header>
                                                                        <v-expansion-panel-content>
                                                                            <v-textarea
                                                                                    rows="5"
                                                                                    @change="fieldChanged"
                                                                                    row-height="3"
                                                                                    counter
                                                                                    clearable
                                                                                    :rules="[technicalPageFieldValidation(colorPagesString)]"
                                                                                    v-model="colorPagesString">
                                                                            </v-textarea>
                                                                        </v-expansion-panel-content>
                                                                    </v-expansion-panel>
                                                                </v-expansion-panels>
                                                            </v-col>
                                                            <v-col cols="1" class="pl-13">
                                                                <v-tooltip left>
                                                                    <template v-slot:activator="{ on }">
                                                                        <v-icon v-on="on" class="pb-6 ml-1"
                                                                                color="primary">mdi-help-circle-outline
                                                                        </v-icon>
                                                                    </template>
                                                                    <span>Δηλώνονται μόνο διαστήματα σελίδων ή ακέραιες σελίδες. Π.χ. 40-45,46,52,60-64 κλπ. ,<br/>
                                                                        σε αύξουσα σειρά, χωρίς κενά. Οι σελίδες που δηλώνονται στο πεδίο «Τετράχρωμες σελίδες ενθέτου»,<br/>
                                                                        πρέπει να έχουν δηλωθεί και ως τεχνικές σελίδες στο προηγούμενο βήμα, διαφορετικά θα αγνοούνται.
                                                                    </span>
                                                                </v-tooltip>
                                                            </v-col>
                                                        </v-row>

                                                        <v-row>
                                                            <v-checkbox
                                                                v-if="!isTechnicalBook"
                                                                :readonly="readOnlyMode"
                                                                @change="fieldChanged"
                                                                color="primary"
                                                                label="Το σύγγραμμα περιέχει ένθετο"
                                                                v-model="hasSupplement"
                                                            ></v-checkbox>
                                                        </v-row>

                                                        <v-row v-if="!isTechnicalBook && hasSupplement">
                                                            <v-checkbox
                                                                    :readonly="readOnlyMode"
                                                                    @change="fieldChanged"
                                                                    color="primary"
                                                                    label="Το ένθετο αποτελείται από αριθμημένες σελίδες"
                                                                    v-model="isSupplementNumbered"
                                                            ></v-checkbox>
                                                            <v-tooltip right>
                                                                <template v-slot:activator="{ on }">
                                                                    <v-icon v-on="on" class="pb-1 pl-2" color="primary">mdi-help-circle-outline</v-icon>
                                                                </template>
                                                                <span>
                                                                    Αφορά σε ένθετο που διαθέτει συνεχή αρίθμηση σε σχέση με το υπόλοιπο σύγγραμμα.<br/>
                                                                    Ένθετα με ασυνεχή ή καθόλου αρίθμηση θα πρέπει να κοστολογούνται ως μη αριθμημένα.
                                                                 </span>
                                                            </v-tooltip>
                                                        </v-row>

                                                        <v-row v-if="!isTechnicalBook && hasSupplement && !isSupplementNumbered"
                                                               class="px-2">
                                                            <v-text-field
                                                                    :readonly="readOnlyMode"
                                                                    dense
                                                                    @change="fieldChanged"
                                                                    label="Συνολικές σελίδες ενθέτου*"
                                                                    outlined
                                                                    required
                                                                    type="number"
                                                                    min="1"
                                                                    :rules="pagesRules"
                                                                    v-model="supplementTotalPages"
                                                            ></v-text-field>
                                                            <v-tooltip left>
                                                                <template v-slot:activator="{ on }">
                                                                    <v-icon v-on="on" class="pb-6 ml-1" color="primary">
                                                                        mdi-help-circle-outline
                                                                    </v-icon>
                                                                </template>
                                                                <span>
                                                            Οι συνολικές σελίδες μη αριθμημένου ενθέτου θα προστεθούν<br/>
                                                            αυτόματα στις σελίδες κεφαλαίων του συγγράμματος.
                                                          </span>
                                                            </v-tooltip>
                                                        </v-row>

                                                        <v-row v-if="!isTechnicalBook && hasSupplement && !isSupplementNumbered"
                                                               class="px-2">
                                                            <v-text-field
                                                                    :readonly="readOnlyMode"
                                                                    @change="fieldChanged"
                                                                    dense
                                                                    label="Θέση ενθέτου στο σύγγραμμα*"
                                                                    outlined
                                                                    required
                                                                    :rules="[supplementPositionFieldValidation]"
                                                                    v-model="supplementPosition"
                                                            ></v-text-field>
                                                            <v-tooltip left>
                                                                <template v-slot:activator="{ on }">
                                                                    <v-icon v-on="on" class="pb-6 ml-1" color="primary">
                                                                        mdi-help-circle-outline
                                                                    </v-icon>
                                                                </template>
                                                                <span>
                                                              Σημειώστε τη θέση του ενθέτου μέσα στο σύγγραμμα (π.χ. στο τέλος<br/>
                                                              του βιβλίου, μετά τη σελ. 30, κτλ.). Πεδίο ελεύθερου κειμένου.
                                                          </span>
                                                            </v-tooltip>
                                                        </v-row>
                                                        <v-row v-if="!isTechnicalBook && hasSupplement && isSupplementNumbered" class="px-2">
                                                            <v-col cols="11" class="pa-0">
                                                                <v-expansion-panels class="pb-6">
                                                                    <v-expansion-panel>
                                                                        <v-expansion-panel-header
                                                                                :color="changeColor(supplementColorPagesString)">
                                                                            Τετράχρωμες σελίδες ενθέτου
                                                                        </v-expansion-panel-header>
                                                                        <v-expansion-panel-content>
                                                                            <v-textarea
                                                                                    rows="5"
                                                                                    @change="fieldChanged"
                                                                                    row-height="3"
                                                                                    counter
                                                                                    clearable
                                                                                    :rules="[technicalPageFieldValidation(supplementColorPagesString)]"
                                                                                    v-model="supplementColorPagesString">
                                                                            </v-textarea>
                                                                        </v-expansion-panel-content>
                                                                    </v-expansion-panel>
                                                                </v-expansion-panels>
                                                            </v-col>
                                                            <v-col cols="1">
                                                                <v-tooltip left>
                                                                    <template v-slot:activator="{ on }">
                                                                        <v-icon v-on="on" class="pb-6 ml-1"
                                                                                color="primary">mdi-help-circle-outline
                                                                        </v-icon>
                                                                    </template>
                                                                    <span>
                                                                      Δηλώνονται μόνο διαστήματα σελίδων ή ακέραιες σελίδες. <br/>
                                                                      Π.χ. 40-45,46,52,60-64 κλπ. σε αύξουσα σειρά, χωρίς κενά. Οι σελίδες<br/>
                                                                      που δηλώνονται στο πεδίο «Τετράχρωμες σελίδες ενθέτου»<br/>
                                                                      πρέπει να έχουν δηλωθεί και ως τεχνικές σελίδες στο προηγούμενο<br/>
                                                                      βήμα, διαφορετικά θα αγνοούνται.
                                                                    </span>
                                                                </v-tooltip>
                                                            </v-col>
                                                        </v-row>

                                                        <v-row v-if="!isTechnicalBook && hasSupplement && !isSupplementNumbered" class="px-2">
                                                            <v-text-field
                                                                    :readonly="readOnlyMode"
                                                                    @change="fieldChanged"
                                                                    dense
                                                                    label="Συνολικές τετράχρωμες σελίδες ενθέτου"
                                                                    min="0"
                                                                    outlined
                                                                    :rules="[supplementColorPageRule,supplementColorPageRuleInComparisonWithTotal]"
                                                                    v-model="supplementColorPagesTotal"
                                                            ></v-text-field>
                                                            <v-tooltip left>
                                                                <template v-slot:activator="{ on }">
                                                                    <v-icon v-on="on" class="pb-6 ml-1" color="primary">
                                                                        mdi-help-circle-outline
                                                                    </v-icon>
                                                                </template>
                                                                <span>
                                                              Οι τετράχρωμες σελίδες ενθέτου δεν πρέπει να υπερβαίνουν τις συνολικές σελίδες ενθέτου.
                                                            </span>
                                                            </v-tooltip>
                                                        </v-row>

                                                    </v-col>
                                                </v-row>
                                            </v-form>
                                        </v-card-text>
                                    </v-card>
                                    <v-row class="justify-center">
                                        <v-btn  color="primary"
                                                class="mr-1"
                                                @click="e1 = 2">
                                            <v-icon>chevron_left</v-icon> Πίσω
                                        </v-btn>
                                        <v-btn  color="primary"
                                                :disabled="!valid3"
                                                @click="goToFinalStepButtonClick">
                                            Συνέχεια <v-icon>chevron_right</v-icon>
                                        </v-btn>
                                    </v-row>
                                </v-stepper-content>

                                <v-stepper-content step="4">
                                    <v-row class="justify-center"> <h2> Σύνοψη Κοστολόγησης </h2> </v-row>

                                    <v-card class="mb-2" flat
                                            color="grey lighten-4">
                                        <v-card-text>
                                            <table style="width:100%" class="mainTable">
                                                <tr>
                                                    <th>Κριτήρια αξιολόγησης</th>
                                                    <th>Δηλωθέντα στοιχεία</th>
                                                    <th>Στοιχεία κοστολόγησης</th>
                                                </tr>
                                                <tr>
                                                    <td>Διαστάσεις</td>
                                                    <td>{{ computeDimensionsString }} εκ.</td>
                                                    <td>{{ this.dimensionsAlgorithmValue }} εκ.</td>
                                                </tr>
                                                <tr>
                                                  <td>Πλαϊνά περιθώρια</td>
                                                  <td>{{ this.sideGap }}</td>
                                                  <td>{{ this.sideGapAlgorithmValue }}</td>
                                                </tr>
                                                <tr>
                                                    <td>Σελίδες πριν τα κεφάλαια</td>
                                                    <td>{{ this.preChapterPages }}</td>
                                                    <td>{{ this.preChapterPagesAlgorithmValue }}</td>
                                                </tr>
                                                <tr>
                                                    <td>Σελίδες κεφαλαίων</td>
                                                    <td>{{ this.computeChapterPagesForFinalTable }}</td>
                                                    <td>{{ this.chapterPagesAlgorithmValue }}</td>
                                                </tr>
                                                <tr>
                                                    <td>Σελίδες μετά τα κεφάλαια</td>
                                                    <td>{{this.postChapterPages}}</td>
                                                    <td>{{ this.postChapterPagesAlgorithmValue }}</td>
                                                </tr>
                                                <tr>
                                                    <td>Τετράχρωμες σελίδες</td>
                                                    <td>{{ this.getColorPageStringForFinalTable }}</td>
                                                    <td>{{ this.colorPagesAlgorithmValue }}</td>
                                                </tr>
                                                <tr>
                                                    <td>Αράδες</td>
                                                    <td>{{ this.lines }}</td>
                                                    <td>{{ this.isTechnicalBook ? '' : this.linesAlgorithmValue }}</td>
                                                </tr>
                                                <tr>
                                                    <td>Κλωστοραφή</td>
                                                    <td colspan="2">{{ this.fiberBinding? 'Ναι' : 'Όχι' }}</td>
                                                </tr>
                                            </table>
                                            <v-row >
                                                <v-col cols="1"  >

                                                    <v-tooltip bottom>
                                                        <template v-slot:activator="{ on }">
                                                            <v-btn  v-on="on" outlined v-if="openedAsHistory" color="primary" @click="openPercentageReduction" >
                                                                 <v-icon > mdi-percent</v-icon>
                                                                 <v-icon class="pl-2"> search</v-icon>
                                                            </v-btn>
                                                        </template>
                                                        <span> Προβολή ποσοστιαίας μείωσης από την επιτροπή.</span>
                                                    </v-tooltip>
                                                </v-col>
                                                <v-spacer/>
                                                <v-col cols="3" >
                                                    <table style="width:70%" class="ml-8">
                                                        <tr>
                                                            <td class="py-1">Τιμή: {{retailPriceAlgorithmValue}} <v-icon small>euro</v-icon> </td>
                                                        </tr>
                                                    </table>
                                                </v-col>

                                                <v-col cols="4">
                                                    <v-tooltip top>
                                                        <template v-slot:activator="{ on }">
                                                            <v-btn block v-on="on" color="primary" :readonly="readOnlyMode" @click="openCommentsDialog">
                                                                {{openedAsHistory? 'Προβολή σχολίων' :'Προσθήκη σχολίων'}}  <v-icon class="pl-2"> mdi-tooltip-edit</v-icon>
                                                            </v-btn>
                                                        </template>
                                                        <span> Προσθήκη σχολίων αναφορικά με τα δεδομένα κοστολόγησης.</span>
                                                    </v-tooltip>

                                                </v-col>
                                                <v-col cols="4">
                                                    <v-btn block :disabled="readOnlyMode" color="primary" :readonly="readOnlyMode" @click="tempSaveButtonClick">
                                                        Προσωρινή αποθήκευση  <v-icon class="pl-2"> mdi-check</v-icon>
                                                    </v-btn>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col v-if="renderForTestOnly" cols="4">
                                                    Τιμή βάσης: {{ this.idealBookPrice }} <v-icon small>euro</v-icon>
                                                </v-col>

                                                <v-col v-else cols="4">

                                                </v-col>
                                                <v-col cols="4">
                                                    <v-btn :disabled="readOnlyMode" @click="liabilityDialog = true" :readonly="readOnlyMode" block  color="primary">
                                                        Οριστική υποβολή  <v-icon class="pl-2"> mdi-check-all</v-icon>
                                                    </v-btn>
                                                </v-col>
                                                <v-col cols="4">
                                                    <v-btn block  color="primary" @click="getResultPdfFile">
                                                        Αναφορά
                                                        <v-icon class="pl-2">mdi-file-pdf-box</v-icon>
                                                    </v-btn>
                                                </v-col>

                                            </v-row>
                                        </v-card-text>
                                    </v-card>
                                    <v-btn  color="primary"
                                            class="mr-1"
                                            @click="e1 = 3">
                                        <v-icon>chevron_left</v-icon> Πίσω
                                    </v-btn>
                                </v-stepper-content>
                            </v-stepper-items>
                        </v-stepper>
                        </v-col>
                    </v-row>


                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="primary"
                            text
                            @click="closeButtonClicked">
                        Κλείσιμο
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog persistent max-width="550" v-model="commentsDialog">
            <v-card style="background-color: #07575b" >
                <v-card-title class="justify-center "  >
                    <v-spacer/>
                    <span class="headline white--text"> Σχόλια </span>
                    <v-spacer/>
                    <v-tooltip left>
                        <template v-slot:activator="{ on }">
                            <v-icon large v-on="on" class="pt-1"
                                    color="white">mdi-help-circle-outline
                            </v-icon>
                        </template>
                        <span> Προσθήκη σχολίων αναφορικά με τα δεδομένα κοστολόγησης.</span>
                    </v-tooltip>
                </v-card-title>
                <v-card-text style="background-color: rgb(212,213,210)">
                    <v-form class="pt-4" v-model="commentsFormValid">
                        <v-textarea
                                auto-grow
                                @change="fieldChanged"
                                row-height="5"
                                counter
                                clearable
                                :rules="commentsRules"
                                label="Σχόλια κοστολόγησης"
                                v-model="comments">
                        </v-textarea>
                    </v-form>
                </v-card-text>
                <v-card-actions style="background-color: rgb(212,213,210)" class="justify-center pa-0 pb-2">

                    <v-btn style="min-width: 150px" @click="closeCommentsDialog"  color="white" > Άκυρο </v-btn>
                    <v-btn style="min-width: 150px" @click="saveCommentForRequest" :disabled="readOnlyMode ? true : !commentsFormValid" color="secondary" > ΟΚ</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog persistent
                  v-model="closeConfirmationDialog"
                  max-width="400">

          <v-card>
            <v-card-title
                class="headline primary white--text"
                primary-title>
              Επιβεβαίωση εξόδου
            </v-card-title>

            <v-card-text class="mt-5">
                Έχετε μη αποθηκευμένες αλλαγές στα στοιχεία κοστολόγησης του συγγράμματος.  Αν κλείσετε την εφαρμογή, θα χαθούν.
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="closeConfirmationDialog = false">
                Άκυρο
              </v-btn>
              <v-btn color="error" @click="closeConfirmationDialog = false; closeModal();">
                Έξοδος και διαγραφή αλλαγών
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog persistent
                  v-model="submitConfirmationDialog"
                  max-width="400">

            <v-card>
                <v-card-title
                        class="headline primary white--text"
                        primary-title>
                    Επιβεβαίωση υποβολής
                </v-card-title>

                <v-card-text class="mt-5">
                    Προσοχή! Μπορείτε να υποβάλετε οριστικά μία (1) μόνο αίτηση κοστολόγησης. Δεν θα μπορείτε να επεξεργαστείτε την αίτηση κοστολόγησης μετά από αυτήν την ενέργεια. Είστε βέβαιος/η;
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="submitConfirmationDialog = false" color="error">
                        Όχι <v-icon>close</v-icon>
                    </v-btn>
                    <v-btn color="success" @click="confirmPricingButtonClick">
                        Ναι <v-icon>done</v-icon>
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog persistent
                  v-model="tempSaveSuccessDialog"
                  max-width="400">

          <v-card>
            <v-card-title
                class="headline primary white--text"
                primary-title>
              Ενημέρωση
            </v-card-title>

            <v-card-text class="mt-5">
              Η αίτησή σας καταχωρίστηκε επιτυχώς. <b>Προσοχή! Η
              προσωρινή αποθήκευση δεν αποτελεί οριστικοποίηση</b>. Για την ολοκλήρωση της διαδικασίας
              οφείλετε να οριστικοποιήσετε την αίτησή σας εντός των καθορισμένων χρονικών ορίων.
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="tempSaveSuccessDialog = false">
                 Ενημερώθηκα <v-icon>close</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog persistent
                  v-model="liabilityDialog"
                  max-width="400">

          <v-card>
            <v-card-title
                class="headline primary white--text"
                primary-title>
              Γνωστοποίηση ευθύνης
            </v-card-title>

            <v-card-text class="mt-5">
              Με την παρούσα αίτηση δηλώνω υπεύθυνα και γνωρίζοντας τις συνέπειες,
              που προβλέπονται από το Νόμο, ότι τα στοιχεία που εισάγω για το σύγγραμμα με
              μοναδικό κωδικό <b>{{selectedBookId}}</b> στο Πληροφοριακό Σύστημα «Εύδοξος» είναι
              αληθή, ορθά και ακριβή.
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="liabilityDialog = false" color="gray">
                Άκυρο <v-icon>close</v-icon>
              </v-btn>
              <v-btn color="gray" @click="liabilityDialog = false; submitConfirmationDialog = true;">
                  Συμφωνώ <v-icon>done</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <TextAndPercentageDialog :show-percentage="true"
                                 :read-only-mode="openedAsHistory"
                                 :component-key="textAndPercentageDialogKey"
                                 :text-input="percentageReductionText === null ||percentageReductionText === undefined ? '':percentageReductionText"
                                 :percentage-input="percentageReduction === null ||percentageReduction === undefined ? 0 :percentageReduction"

        />
        <CommentsDialog :read-only-mode="openedAsHistory" :component-key="commentsDialogKey" v-model="comments" :comment-input="comments"/>
    </div>
</template>

<script>
    import Utilities from "../../../utilities"
    import requests from "@/requests";
    import {eventBus} from "../../../main";
    import TextAndPercentageDialog from "./TextAndPercentageDialog";
    import CommentsDialog from "../../CommentsDialog";

    export default {
        components:{TextAndPercentageDialog,CommentsDialog},
        name: "PricingModal",
        data: () => ({
            textAndPercentageDialogKey:1000,
            headerColor1:'',
            valid1: true,
            valid2: true,
            valid3: true,
            readOnlyMode: false,
            readOnlyFiberBindingFromPageFolding: false,
            liabilityDialog: false,
            submitConfirmationDialog: false,
            closeConfirmationDialog: false,
            tempSaveSuccessDialog: false,
            fab: false,
            e1: 1,
            id:'', // this will be the DB id
            finalized: false,
            changesSaved: true,
            lines: '',
            linesAlgorithmValue: '',
            x: null,
            y: null,
            pageFolding: 0,
            dimensions: '',
            dimensionsAlgorithmValue: '',
            foldingItem: [
                {id: 0, label: '1'},
                {id: 1, label: '8'},
                {id: 2, label: '16'}
            ],
            dimensionItem: [
                {id: 0, label: '14x21'},
                {id: 1, label: '17x24'},
                {id: 2, label: '21x29'},
                {id: 3, label: 'Άλλο'}
            ],
            totalPages: 0,
            preChapterPages: 0,
            preChapterPagesAlgorithmValue: '',
            postChapterPages: 0,
            postChapterPagesAlgorithmValue: '',
            totalSingleColorChapterPages:0,
            chapterPages: 1,
            firstChapterPage: 1,
            commentsDialog: false,
            savedComment: false,
            comments: '', // this is from the backend object
            commentForRequest:'',
            commentsFormValid: false,
            commentsRules: [v => v.length <= 1000 || 'Τα σχόλια μπορούν να έχουν μήκος 1000 χαρακτήρες'],
            chapterPagesAlgorithmValue: '',
            technicalPagesString: '',
            technicalPreChapterPages: 0,
            testing: '',
            technicalPagesTotal: 0,
            isTechnicalBook: Boolean,
            colorPagesString: '',
            colorPagesTotal: '',
            colorPagesAlgorithmValue: '',
            fiberBinding: false,
            hasSupplement: false,
            supplementTotalPages: '',
            supplementPosition: '',
            isSupplementNumbered: true,
            supplementColorPagesString: '',
            supplementColorPagesTotal: '',
            sideGap: '',
            sideGapAlgorithmValue: '',
            retailPriceAlgorithmValue: 0,
            idealBookPrice: 0,
            percentageReduction: 0,
            percentageReductionText: '',
            commentsDialogKey:1000,
            pagesRules: [
                v => {if (v===null || v === undefined || v==='') return 'Το πεδίο είναι υποχρεωτικό'; else return true;},
                v => {if (String(v).includes('.')) return 'Οι σελίδες πρέπει να είναι θετικός ακέραιος αριθμός'; else return true;},
                v => {if (Number(v) < 1 || Number(v) > 3000) return 'Οι σελίδες πρέπει να ανήκουν στο εύρος 1-3000'; else return true;},
            ],
            pagesRulesThatAllowZero: [
                v => {if (v===null || v === undefined || v==='') return 'Το πεδίο είναι υποχρεωτικό'; else return true;},
                v => {if (String(v).includes('.')) return 'Οι σελίδες πρέπει να είναι θετικός ακέραιος αριθμός'; else return true;},
                v => {if (Number(v) < 0 || Number(v) > 3000) return 'Οι σελίδες πρέπει να ανήκουν στο εύρος 0-3000'; else return true;},
            ],
            wholeNumberRule: [
                v => /^([1-9][0-9]*)$/.test(v) || 'Οι σελίδες πρέπει να είναι θετικός ακέραιος αριθμός',
            ],
            required: [
                v => !!v || 'Το πεδίο είναι υποχρεωτικό',
            ],
            lineRules: [
                v => !!v || 'Το πεδίο είναι υποχρεωτικό',
                v => {
                  if (v < 1 || v > 100)
                    return 'Οι αράδες πρέπει να ανήκουν στο εύρος 1-100';
                  if (v.toString().includes(".") || v.toString().includes(","))
                    return 'Οι αράδες πρέπει να είναι ακέραιος αριθμός';
                  return true;
                },
            ],
            xRules: [
                v => !!v || 'Το πεδίο είναι υποχρεωτικό',
                v =>  /^([1-9][0-9]*(\.[0-9])?)$/.test(v) || 'Μη επιτρεπτή τιμή',
                v => { if (Number(v) < 1 || Number(v) > 99) return 'Η διάσταση πρέπει να βρίσκεται στο εύρος 1-99, π.χ. 18.5'; else return true;},
            ],
            yRules: [
                v => !!v || 'Το πεδίο είναι υποχρεωτικό',
                v =>  /^([1-9][0-9]*(\.[0-9])?)$/.test(v) || 'Μη επιτρεπτή τιμή',
                v => { if (Number(v) < 1 || Number(v) > 99) return 'Η διάσταση πρέπει να βρίσκεται στο εύρος 1-99, π.χ. 23.5'; else return true;},
            ],
            sideGapRules: [
              v => !!v || 'Το πεδίο είναι υποχρεωτικό',
              v => {
                if (v < 1 || v > 10)
                  return 'Επιτρέπονται τιμές από το 1 μέχρι και το 10';
                if (v % 0.5 !== 0)
                  return 'Το περιθώριο πρέπει να είναι της μορφής 5, 5.5, 6, 6.5 κτλ';
                return true;
              },
            ],
        }),

        props: {
          selectedBookId: Number,
          pricingObj: Object,
          bookTitle: String,
          openedAsHistory:Boolean
        },

        methods: {

            openCommentsDialog(){
                this.commentsDialogKey++;
            },

            openPercentageReduction(){
                this.textAndPercentageDialogKey++;
                this.$store.commit('setTextAndPercentageDialog', true);

            },

            changeColor(pagesString){
                if(this.checkIfNotEmptyUndefinedOrNull(pagesString)){
                    return this.technicalPageFieldValidation(pagesString)===true ? '#ffffff' : '#cd5c5c';
                }else{
                    return '#ffffff';
                }
            },
            step2Validation(){
                console.log(this.isTechnicalBook);
                if(this.valid2) {
                    this.e1 = 3;
                }else{
                    this.$refs.step2.validate();
                }
            },

            closeCommentsDialog(){

                if(this.pricingObj.comments !== null && this.pricingObj.comments !== undefined && this.pricingObj.comments !== ''){ //it means he had a saved comment
                    this.comments = this.pricingObj.comments;
                }else{ // he didn't have a saved comment he wrote something and canceled so we clear it
                    if(!this.savedComment){// if he pressed at least 1 ok don't clear it at close
                        this.comments = '';
                    }
                }
                this.commentsDialog = false;
            },

            saveCommentForRequest(){
                this.commentForRequest = this.comments;
                this.commentsDialog = false;
                this.savedComment = true;
            },

            goToUrl(url) {
              window.open(url, '_blank');
            },

            getResultPdfFile(){
                var requestObj ={ bookId:this.selectedBookId,
                                  bookPricing:{ id: this.id }
                };
                this.$store.commit('setLoadingModal', true);
                if(this.openedAsHistory){
                    requests.postForFiles('rest/pricing/get-history-pdf', requestObj, this.getResultPdfFileCallBack); // history has DB generated id it gets populated at created()
                }else{
                    requests.postForFiles('rest/pricing/get-pdf', requestObj, this.getResultPdfFileCallBack);// pricing has ID same as book id  it comes as prop
                }
            },

            getResultPdfFileCallBack(response) {
                this.$store.commit('setLoadingModal', false);
                Utilities.downLoadPDFNewTab(response);
            },

            openManual() {
              let path;
              if (this.e1 == 1)
                path = 'https://eudoxus.gr/files/PublisherCostingManual1.pdf';
              else if (this.e1 == 2)
                path = 'https://eudoxus.gr/files/PublisherCostingManual2.pdf';
              else if (this.e1 == 3)
                path = 'https://eudoxus.gr/files/PublisherCostingManual3.pdf';
              else if (this.e1 == 4)
                path = 'https://eudoxus.gr/files/PublisherCostingManual4.pdf';

              window.open(path, '_blank');
            },

            technicalPageFieldValidation(v) {

                if (!v)
                    return true;

                if (v.toString().length > 2500)
                    return 'Το πεδίο δεν πρέπει να ξεπερνά τους 2.500 χαρακτήρες.';

                if (!/^(|(([1-9][0-9]{0,3}\s*(-\s*[1-9][0-9]{0,3})?(?=,.|$),?))+)$/.test(v))
                    return 'Το πεδίο δεν είναι αποδεκτό';

                if (/\s/g.test(v))
                    return 'Το πεδίο δεν είναι αποδεκτό';

                // Check if the page numbers are in ascending order
                let techArray = v.split(",");
                let lastPageFound = -1;
                for (let te in techArray) {
                    if (techArray[te]) {
                        let currentInterval = techArray[te];

                        if (currentInterval.indexOf("-") === -1) {
                            if (lastPageFound > Number(currentInterval))
                                return 'Οι σελίδες πρέπει να είναι σε αύξουσα σειρά';
                            else if (lastPageFound == Number(currentInterval))
                                return 'Υπάρχει επικάλυψη σελίδας';
                            else if (Number(this.firstChapterPage) > Number(currentInterval))
                                return 'Περιέχονται σελίδες πριν την πρώτη σελ. κεφαλαίων.';
                            lastPageFound = Number(currentInterval);

                        } else {
                            let distanceArray = [];
                            let distance = currentInterval.split("-");
                            for (let d in distance) {
                                if (distance[d]) {
                                    if (Number(this.firstChapterPage) > Number(distance[d]))
                                        return 'Περιέχονται σελίδες πριν την πρώτη σελ. κεφαλαίων.';
                                    distanceArray.push(Number(distance[d]));
                                }
                            }
                            if (distanceArray[0] < lastPageFound || distanceArray[1] < distanceArray[0])
                                return 'Οι σελίδες πρέπει να είναι σε αύξουσα σειρά';
                            else if (distanceArray[0] == lastPageFound || distanceArray[1] == distanceArray[0])
                                return 'Υπάρχει επικάλυψη σελίδας';
                            lastPageFound = distanceArray[1];
                        }
                    }
                }
                return true;
            },

            supplementPositionFieldValidation() {
              if (!this.supplementPosition)
                return 'Το πεδίο είναι υποχρεωτικό';

              if (this.supplementPosition.length > 150)
                return 'Όριο χαρακτήρων: 150';
              return true;
            },

            fieldChanged() {
                this.changesSaved = false;
            },

            stepper4ClickEvent() {
                if (this.openedAsHistory) {
                    this.e1 = 4;
                } else {
                    if (this.valid3 && this.valid2 && this.valid1) {
                        this.goToFinalStepButtonClick();
                    }
                }

            },

            goToFinalStepButtonClick() {
                if (this.openedAsHistory) {
                    this.e1 = 4;
                } else {
                    this.$store.commit('setLoadingModal', true);

                    if (this.hasSupplement) {
                        if (this.isSupplementNumbered) {
                            this.supplementColorPagesTotal = this.getPageNumberFromString(this.supplementColorPagesString, true);
                        }
                    } else {
                        this.colorPagesTotal = this.getPageNumberFromString(this.colorPagesString, true);
                    }

                    this.calculatePricingInfoRequest();
                }

            },

            tempSaveButtonClick() {
              this.$store.commit('setLoadingModal', true);
              this.sendTempSavePricingRequest();
            },

            confirmPricingButtonClick() {
              // # # # # Uncomment WHEN TESTING FINISHES # # # #
               this.$store.commit('setLoadingModal', true);
               this.sendSubmitBookPricingRequest();
               this.finalized = true;
              this.submitConfirmationDialog = false;
            },

            closeButtonClicked() {
              if (!this.changesSaved)
                this.closeConfirmationDialog = true;
              else
                this.closeModal();
            },

            closeModal() {

                this.$store.commit('setPricingModal', false);
                this.e1 = 1;
            },

            getPageNumberFromString(pagesString, countNonChapterPages = false) {
                //var pagesToShift = Number(this.preChapterPages) -Number(this.firstChapterPage) +1
                if (pagesString) {
                    let pagesToShift = Number(this.preChapterPages) - Number(this.firstChapterPage) +1;
                    let techArray = pagesString.split(",");
                    let finalPage = Number(this.preChapterPages) + Number(this.postChapterPages) + Number(this.chapterPages);
                    let total = {};
                    for (let te in techArray) {
                        if (techArray[te]) {
                            let currentInterval = techArray[te];

                            if (currentInterval.indexOf("-") === -1) {
                                if (Number(currentInterval) + pagesToShift > 0 && Number(currentInterval) + pagesToShift <= finalPage && (countNonChapterPages || ( Number(currentInterval) + pagesToShift > Number(this.preChapterPages) && Number(currentInterval) + pagesToShift <= Number(this.preChapterPages) + Number(this.chapterPages))) )
                                  total[currentInterval] = true;
                            }else {
                                let distanceArray = [];
                                let distance = currentInterval.split("-");
                                for (let d in distance) {
                                    if (distance[d]) {
                                        distanceArray.push(Number(distance[d]));
                                    }
                                }
                                if (distanceArray.length > 1) {

                                    for (let i = distanceArray[0]; i <= distanceArray[1]; i++){
                                        if (i  + pagesToShift > 0 && i + pagesToShift <= finalPage && (countNonChapterPages || (i + pagesToShift > Number(this.preChapterPages) && i + pagesToShift <= Number(this.preChapterPages) + Number(this.chapterPages))) )
                                          total[i] = false;
                                    }
                                }
                            }
                        }
                    }
                    this.technicalPagesTotal = Object.keys(total).length;
                    return Object.keys(total).length;
                }
            },

            calculatePricingInfoRequest() {
              let dataObj = this.constructBookPricingModel();

              // Send the request
              requests.calculateBookPricingInfo(Utilities.getLocalStorage('token'), dataObj, this.calculatePricingInfoCallback)
            },

            calculatePricingInfoCallback(response) {

              this.setDataVariablesFromResponse(response);
              this.e1 = 4;

              this.$store.commit('setLoadingModal', false);
            },

            sendSubmitBookPricingRequest() {
              let dataObj = this.constructBookPricingModel();

              // Send the request
              requests.submitPricingForBook(Utilities.getLocalStorage('token'), dataObj, this.submitBookPricingCallback);
            },

            submitBookPricingCallback(response) {
              this.setDataVariablesFromResponse(response);
              this.changesSaved = true;
              for(var k =0;k<this.$store.getters.publisherBooks.length;k++){
                  if(this.$store.getters.publisherBooks[k].id == this.selectedBookId){
                      let bookId = this.$store.getters.publisherBooks[k].id;

                      requests.getBookInfo(Utilities.getLocalStorage('token'), bookId, (response) => {
                          // Update the book store variables with the new pricing info from database
                          this.$store.getters.publisherBooks.splice(k, 1, response);
                          this.$store.commit('setEditPublisherBook', this.$store.getters.publisherBooks[k]);

                          eventBus.$emit('createEditFields', true);
                          this.$store.commit('setLoadingModal', false);
                          Utilities.setSuccessPopup('Επιτυχής καταχώριση!',true);
                      });
                      break;
                  }
              }
            },

            asyncRefreshFinalisedByPublisher(resp){
              for(var k =0;k<this.$store.getters.publisherBooks.length;k++){
                if(this.$store.getters.publisherBooks[k].id == this.selectedBookId){
                  this.$store.getters.publisherBooks[k].finalizedByPublisher = resp.finalizedByPublisher;
                  this.$store.commit('setEditPublisherBook', this.$store.getters.publisherBooks[k]);
                  eventBus.$emit('createEditFields', true);
                  break;
                }
              }
            },

            sendTempSavePricingRequest() {
              let dataObj = this.constructBookPricingModel();

              // Send the request
              requests.tempSavePricingForBook(Utilities.getLocalStorage('token'), dataObj, this.tempSavePricingCallback);
            },

            tempSavePricingCallback(response) {
              this.setDataVariablesFromResponse(response);
              this.changesSaved = true;

              this.$store.commit('setLoadingModal', false);
              this.tempSaveSuccessDialog = true;
            },

            // This function constructs the Pricing Model object that is sent to the back for various requests
            constructBookPricingModel() {
                let dataObj = {
                    bookId: this.selectedBookId,
                    bookPricing: {
                        id: this.id,
                        category: this.isTechnicalBook ? 'TECHNICAL' : 'SIMPLE',
                        chapterPages: this.chapterPages,
                        dimensions: this.dimensions == 'Άλλο' ? (this.x + 'x' + this.y) : this.dimensions,
                        lines: this.lines,
                        pageFolding: this.pageFolding.label,
                        postChapterPages: this.postChapterPages,
                        technicalPreChapterPages: this.technicalPreChapterPages,
                        firstChapterPage: this.firstChapterPage,
                        lastChapterPage: this.lastChapterPage,
                        preChapterPages: this.preChapterPages,
                        sideGap: this.sideGap,
                        technicalPagesString: this.technicalPagesString==null? '': this.technicalPagesString,
                        technicalPagesTotal: this.technicalPagesTotal,
                        totalPages: this.totalPages,
                        colorPagesUser: this.getColorPageStringForFinalTable,
                        fiberBinding: this.fiberBinding
                    }
                };

              if(this.isTechnicalBook){
                  dataObj.bookPricing.totalSingleColorChapterPages = this.totalSingleColorChapterPages;
              }

              dataObj.bookPricing.comments = this.comments;


              // Handle fields that are not always required
              if (this.isTechnicalBook) {
                dataObj.bookPricing.colorPagesString = this.colorPagesString==null? '': this.colorPagesString;
              }
              else {
                dataObj.bookPricing.hasSupplement = this.hasSupplement;
                if (this.hasSupplement) {
                  dataObj.bookPricing.isSupplementNumbered = this.isSupplementNumbered;
                  if (this.isSupplementNumbered) {
                    dataObj.bookPricing.supplementColorPagesString = this.supplementColorPagesString==null? '': this.supplementColorPagesString;
                  }
                  else {
                    dataObj.bookPricing.supplementPosition = this.supplementPosition;
                    dataObj.bookPricing.supplementTotalPages = this.supplementTotalPages;
                    dataObj.bookPricing.supplementColorPagesTotal = this.supplementColorPagesTotal;
                  }
                }
              }
              return dataObj;
            },

            setDataVariablesFromResponse(response) {
                // Set the algorithm values variables
                this.dimensionsAlgorithmValue = response.dimensionsAlgorithmValue;
                this.preChapterPagesAlgorithmValue = response.preChapterPagesAlgorithmValue;
                this.chapterPagesAlgorithmValue = response.chapterPagesAlgorithmValue;
                this.postChapterPagesAlgorithmValue = response.postChapterPagesAlgorithmValue;
                this.colorPagesAlgorithmValue = response.colorPagesAlgorithmValue;
                this.linesAlgorithmValue = response.linesAlgorithmValue;
                this.sideGapAlgorithmValue = response.sideGapAlgorithmValue;
                this.id = response.id;

                this.retailPriceAlgorithmValue = response.retailPriceAlgorithmValue;
                this.idealBookPrice = String(response.idealBookPrice).replace(".", "@").replace(",", ".").replace("@", ",");

            },

            checkTotalSingleColorChapterPagesRule(){
                if (this.totalSingleColorChapterPages === null || this.totalSingleColorChapterPages === undefined || this.totalSingleColorChapterPages === "") {
                    return 'Το πεδίο είναι υποχρεωτικό';
                }else{
                    var totalSingleColorChapterPagesNumber = Number(this.totalSingleColorChapterPages);
                    var preChapterPagesNumber = Number(this.preChapterPages);
                    var chapterPagesNumber = Number(this.chapterPages);

                    if(totalSingleColorChapterPagesNumber<0 || totalSingleColorChapterPagesNumber % 1 !==0)
                        return 'Το πεδίο δεν είναι αποδεκτό';

                    if(preChapterPagesNumber>900){
                        if (totalSingleColorChapterPagesNumber!==0)
                            return 'Υπέρβαση των σελ. κεφαλαίων που αντιστοιχούν στις πρώτες 900 σελ. του συγγράμματος';
                    }
                    else if(preChapterPagesNumber + chapterPagesNumber>900){
                        if (totalSingleColorChapterPagesNumber > 900 - preChapterPagesNumber)
                            return 'Υπέρβαση των σελ. κεφαλαίων που αντιστοιχούν στις πρώτες 900 σελ. του συγγράμματος';
                    }else if(totalSingleColorChapterPagesNumber > chapterPagesNumber){
                        return 'Υπέρβαση των σελ. κεφαλαίων που αντιστοιχούν στις πρώτες 900 σελ. του συγγράμματος';
                    }
                }
                return true;
            },

            checkIfNotEmptyUndefinedOrNull(val){
                if(val === '' || val == null || val == undefined) {
                    return false;
                }else {
                    return true;
                }
            },

            checkIfNotEmptyUndefinedOrNull2Values(val1, val2){
                return this.checkIfNotEmptyUndefinedOrNull(val1) &&  this.checkIfNotEmptyUndefinedOrNull(val2);
            },

            checkIfNotEmptyUndefinedOrNull3Values(val1, val2, val3){
                return this.checkIfNotEmptyUndefinedOrNull(val1) &&  this.checkIfNotEmptyUndefinedOrNull(val2) &&  this.checkIfNotEmptyUndefinedOrNull(val3);
            },

            checkIfNotEmptyUndefinedOrNull4Values(val1, val2, val3, val4){
                return this.checkIfNotEmptyUndefinedOrNull2Values(val1, val2) &&  this.checkIfNotEmptyUndefinedOrNull2Values(val3,val4);
            },

            checkIfNotEmptyUndefinedOrNull5Values(val1, val2, val3, val4, val5){
                return this.checkIfNotEmptyUndefinedOrNull(val1)
                    && this.checkIfNotEmptyUndefinedOrNull(val2)
                    && this.checkIfNotEmptyUndefinedOrNull(val3)
                    && this.checkIfNotEmptyUndefinedOrNull(val4)
                    && this.checkIfNotEmptyUndefinedOrNull(val5);
            },
        },

        computed: {

            technicalPreChapterPagesRule(){
                if(this.technicalPreChapterPages == null || this.technicalPreChapterPages === undefined || this.technicalPreChapterPages ==='')
                    return 'Το πεδίο είναι υποχρεωτικό';
                var technicalPreChapterPagesNumber = Number(this.technicalPreChapterPages);
                var preChapterPagesNumber = Number(this.preChapterPages);

                if(technicalPreChapterPagesNumber<0 || String(this.technicalPreChapterPages).includes('.'))
                    return 'Οι σελίδες πρέπει να είναι θετικός ακέραιος αριθμός';
                else if (technicalPreChapterPagesNumber > preChapterPagesNumber )
                    return 'Υπέρβαση σελίδων πριν τα κεφάλαια.';
                else
                    return true;
            },

            firstChapterPageRule(){
                if(this.firstChapterPage == null || this.firstChapterPage == undefined || this.firstChapterPage =='')
                    return 'Το πεδίο είναι υποχρεωτικό';
                if(this.checkIfNotEmptyUndefinedOrNull(this.preChapterPages)) {
                    var firstChapterPageNumber = Number(this.firstChapterPage);
                    var preChapterPagesNumber = Number(this.preChapterPages);
                    if (firstChapterPageNumber < 1 || firstChapterPageNumber % 1 !== 0)
                        return 'Το πεδίο δεν είναι αποδεκτό.';
                    else if (firstChapterPageNumber > preChapterPagesNumber + 1)
                        return 'Το πεδίο δεν είναι αποδεκτό.';
                    else
                        return true;
                }
            },

            lastChapterPage(){
                if(this.firstChapterPage != null && this.firstChapterPage != undefined && this.firstChapterPage !=''){
                    return Number(this.firstChapterPage) + Number(this.chapterPages) -1;
                }else
                    return null;
            },


            renderForTestOnly(){
                return window.location.href.includes('test.eudoxus.gr');
            },

            getColorPageStringForFinalTable : function () {
              let pagesString = this.isTechnicalBook ? this.colorPagesString : (this.hasSupplement ? this.supplementColorPagesString : '');

              if (pagesString)
                return this.getPageNumberFromString(pagesString, true);
              else
                return '0';
            },

            sideGapDimensionRule : function () {
              if (this.dimensions && this.sideGap) {
                let xDim;
                if (this.dimensions == 'Άλλο') {
                  if (this.x)
                    xDim = this.x;
                }
                else
                  xDim = this.dimensions.split('x')[0];

                if (xDim) {
                  if (Number(this.sideGap) >= Number(xDim))
                    return 'Το περιθώριο πρέπει να είναι μικρότερο από την διάσταση x';
                }
              }
              return true;
            },

            supplementColorPageRule : function() {
                if (this.supplementColorPagesTotal) {
                    if (!this.supplementColorPagesTotal.toString().match(/^\+?[0-9]*$/))
                         return 'Οι σελίδες πρέπει να είναι θετικός ακέραιος αριθμός.';
              }
              return true;
            },

            supplementColorPageRuleInComparisonWithTotal : function() {
              if (this.supplementTotalPages && this.supplementColorPagesTotal) {

                if (Number(this.supplementColorPagesTotal) > Number(this.supplementTotalPages))
                  return 'Οι τετράχρωμες σελίδες ενθέτου δεν πρέπει να υπερβαίνουν τις συνολικές σελίδες ενθέτου.';
              }
              return true;
            },

            computeChapterPagesForFinalTable : function() {
              if (!this.isTechnicalBook) {
                if (this.hasSupplement && !this.isSupplementNumbered) {
                  return Number(this.chapterPages) + Number(this.supplementTotalPages);
                }
              }

              return this.chapterPages;
            },

            computeDimensionsString: function () {
              if (this.dimensions) {
                if (this.dimensions == 'Άλλο') {
                  if (this.x && this.y)
                    return this.x + 'x' + this.y;
                }
                else
                  return this.dimensions;
              }
              return '';
            },

            computeTotalPages: function () {
                let check = this.checkIfNotEmptyUndefinedOrNull3Values(this.preChapterPages, this.postChapterPages, this.chapterPages);
                if (check) {
                    return Number(this.preChapterPages) + Number(this.postChapterPages) + Number(this.chapterPages);
                }
                return 0
            },

            bookCategories: function () {
                let check = this.checkIfNotEmptyUndefinedOrNull4Values(this.preChapterPages, this.postChapterPages, this.chapterPages, this.firstChapterPage);
                if (check) {
                    let totalTechnicalPages;
                    if (this.technicalPagesString === '' || this.technicalPagesString === undefined || this.technicalPagesString === null) {
                        totalTechnicalPages = 0;
                    } else {
                        totalTechnicalPages = this.getPageNumberFromString(this.technicalPagesString, true);
                    }

                    totalTechnicalPages += Number(this.technicalPreChapterPages);
                    if ((totalTechnicalPages / (Number(this.preChapterPages) + Number(this.postChapterPages) + Number(this.chapterPages))) * 100 > 40) {
                        console.log(totalTechnicalPages);
                        this.isTechnicalBook = true;
                        return 'Τεχνικό';
                    }

                    this.isTechnicalBook = false;
                    return 'Απλό';
                }
                //return 'Απλό';
            }
        },

        created() {
            //console.log(this.selectedBookId);
            if (Object.keys(this.pricingObj).length !== 0) {

                // Fill all the fields from the request (since they have the same name as the back)
                for (let field in this.pricingObj) {
                    if (this[field] != undefined && field !=='lastChapterPage') {
                        this[field] = this.pricingObj[field];
                    }
                }

                // Treat the page folding variable specially, because it is not a 1-1 assignment
                if (this.pricingObj.pageFolding) {
                    if (this.pricingObj.pageFolding == 1)
                        this.pageFolding = this.foldingItem[0];
                    else if (this.pricingObj.pageFolding == 8)
                        this.pageFolding = this.foldingItem[1];
                    else if (this.pricingObj.pageFolding == 16)
                        this.pageFolding = this.foldingItem[2];
                }

                // Treat the dimensions variable specially, because it is not a 1-1 assignment when a custom value is inserted
                if (this.pricingObj.dimensions) {
                    let dims = this.pricingObj.dimensions;
                    if (dims != "14x21" && dims != "17x24" && dims != "21x29") {
                        let dimsSeparated = dims.split('x');
                        this.dimensions = 'Άλλο';
                        this.x = dimsSeparated[0];
                        this.y = dimsSeparated[1];
                    }
                }
                this.totalSingleColorChapterPages = this.pricingObj.totalSingleColorChapterPages == null ? 0 : this.pricingObj.totalSingleColorChapterPages;

                this.readOnlyMode = this.pricingObj.readOnly;
                this.$store.commit('setLoadingModal', false);
                //console.log(this.selectedBookId);
            }else {
                this.preChapterPages = 0;
                this.postChapterPages = 0;
                this.chapterPages = 1;
            }
        },

        watch: {
          'isTechnicalBook' : function(value) {
            if (value)
              this.hasSupplement = false;
           },
           'comments' : function(val) {
               if(val == null){
                   this.comments = '';
               }
           },
           'firstChapterPage' : function(val) {
               if(val)
                   this.firstChapterPage = val.toString().replace(/^0+(?!$)/,'');
           },
           'pageFolding' : function(val) {
               if(val){
                   if(val.label==='1'){
                       this.fiberBinding = false;
                       this.readOnlyFiberBindingFromPageFolding = true;
                   }else{
                       this.readOnlyFiberBindingFromPageFolding = false;
                   }
               }

           },
           'preChapterPages' : function(val) {
              if(val)
                this.preChapterPages = val.toString().replace(/^0+(?!$)/,'');
           },
           'chapterPages' : function(val) {
              if(val)
                   this.chapterPages = val.toString().replace(/^0+(?!$)/,'');
           },
           'postChapterPages' : function(val) {
               if(val)
                   this.postChapterPages = val.toString().replace(/^0+(?!$)/,'');
           },
           'technicalPagesString' : function(val) {
               console.log(val);
           },
        }
    }
</script>

<style scoped>

    #bookTitle{
        max-width: 70ch
    }

     .mainTable table, th, td {
        border: 1px solid white;
        border-collapse: collapse;
        text-align: center;
    }


    .mainTable tr:nth-child(even) {
        background-color: rgba(150, 212, 212, 0.4);
    }
     .mainTable th:nth-child(even),td:nth-child(even) {
        background-color: rgba(150, 212, 212, 0.4);
    }

    .mainTable tr:hover {background-color: #ffef5a;}

     .secondTable table, th, td {
         border: 1px solid black;
     }
</style>